import { Helmet } from 'react-helmet-async';
import { HighscoreBoard } from '@/components/HighscoreBoard';

const SITE_URL = 'https://highscores.lasertag-arena-siegen.de';
const TITLE = 'Lasertag Siegen Highscores – Arena Siegen live';
const DESCRIPTION =
  'Live Highscores der Lasertag Arena Siegen: Punkte, Trefferquoten, Teamwertungen und Rekorde jedes Spiels – direkt nach der Runde abrufbar.';

const Index = () => {
  return (
    <main>
      <Helmet>
        <title>{TITLE}</title>
        <meta name="description" content={DESCRIPTION} />
        <link rel="canonical" href={`${SITE_URL}/`} />
        <meta property="og:title" content={TITLE} />
        <meta property="og:description" content={DESCRIPTION} />
        <meta property="og:url" content={`${SITE_URL}/`} />
        <meta name="twitter:title" content={TITLE} />
        <meta name="twitter:description" content={DESCRIPTION} />
      </Helmet>

      <HighscoreBoard />
    </main>
  );
};

export default Index;
